import React from 'react';
import { IconProps } from './types';

export const SortUpIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill={color} d='M3.4 16.3L12 7.7l8.6 8.6' />
    </svg>
  );
};
